/**
 * Compute effective status based on dates.
 * @param {object} doc - { type, startDate, endDate, status }
 * @returns {'published'|'ongoing'|'finished'}
 */
export function computeStatus(doc) {
  const now = new Date();
  const start = doc.startDate ? new Date(doc.startDate) : null;
  const end = doc.endDate ? new Date(doc.endDate) : null;

  if (!end) return doc.status || 'published';
  if (now > end) return 'finished';

  if (doc.type === 'event' && start) {
    if (now >= start && now <= end) return 'ongoing';
  }

  return doc.status || 'published';
}

export const STATUS_LABELS = {
  published: 'Publié',
  ongoing: 'En cours',
  finished: 'Terminé',
};

export const TYPE_LABELS = {
  announcement: 'Annonce',
  event: 'Événement',
};

export function getStatusLabel(status) {
  return STATUS_LABELS[status] || status;
}

export function getTypeLabel(type) {
  return TYPE_LABELS[type] || type;
}

export function formatDateFr(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
